export default __webpack_public_path__ + "static/media/MBCorpoSTitle-CondBold.3038b470.otf";